import type { Components } from 'react-markdown';

export const markdownToHtml = async (markdown: string, components: Components = {}) => {
  const [{ renderToStaticMarkup }, { default: ReactMarkdown }, { default: remarkGfm }] = await Promise.all([
    import('react-dom/server'),
    import('react-markdown'),
    import('remark-gfm'),
  ]);

  return renderToStaticMarkup(
    <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
      {markdown}
    </ReactMarkdown>
  );
};
